import { twcls } from '@utils/twcls';
import { observer } from 'mobx-react';
import type { ButtonHTMLAttributes, FC, ReactNode } from 'react';
import './AuthFormBtn.scss';

interface AuthFormBtnProps extends ButtonHTMLAttributes<HTMLButtonElement> {
  children: ReactNode;
}

const AuthFormBtn: FC<AuthFormBtnProps> = observer(
  ({ disabled, onClick, children, className, ...rest }) => (
    <button
      disabled={disabled}
      onClick={onClick}
      {...rest}
      className={twcls('AuthFormBtn', className)}
    >
      {children}
    </button>
  )
);

export default AuthFormBtn;
